import dispatcher from '../dispatcher';
import constants from '../constants';

export function change(geometry) {
    if(geometry != null) {
        dispatcher.dispatch({
            type: constants.GEOMETRY_SET,
            geometry
        });
    }
}